{
  "activateFieldAllActiveErrorMessage": "Todos los campos están activos",
  "activateFieldDescription": "El campo se hará visible inmediatamente en los mapas de la granja.",
  "activateFieldLinkTo": "Activar campo",
  "activateFieldTitle": "Confirmar Activar Campo",
  "archiveFieldAllArchivedErrorMessage": "Todos los campos están archivados",
  "archiveFieldInstructions": "El campo se ocultará de los mapas de la granja y se ignorará en las actualizaciones sobre la ubicación del equipo. Esto no afectará la recopilación de datos; si reactiva el campo, cualquier actividad estará disponible de inmediato.",
  "archiveFieldLinkTo": "Campo de archivo",
  "archiveFieldTitle": "Campo de archivo",
  "archiveFieldsHelpDescription": "Los campos archivados se ocultarán del mapa de estado, pero no se eliminarán y se podrán reactivar en cualquier momento. Es posible que desees hacer esto para los campos que no se utilicen durante una temporada determinada.",
  "areaAcresWithVal": "{{val}} acres",
  "confirmDeleteFieldInputLabel": "Introduzca el nombre del campo",
  "confirmDeleteFieldInstructions": "El campo se eliminará de forma permanente.\n\nEsta acción no se puede deshacer.",
  "confirmDeleteFieldLinkTo": "Eliminar campo",
  "confirmDeleteFieldTitle": "Eliminar campo",
  "enterFieldName": "Introduzca el nombre del campo",
  "fieldArchived": "Este campo está archivado.",
  "fieldIrrigationHistoryLinkTo": "Ver historial de riego",
  "fieldNameInputLabel": "Nombre del campo",
  "fieldNameInputPlaceholder": "¿Cómo se llama el campo?",
  "fieldProfileLandingLinkTo": "Perfil de campo",
  "fieldProfileLandingTitle": "Perfil de campo",
  "fieldsRosterHelpDescription": "Muestra todos los campos que pertenecen a esta granja. Puede archivar y activar campos aquí y también navegar al perfil de cada campo haciendo clic o presionando la tarjeta de campo en la lista.",
  "fieldsRosterLinkTo": "Administrar campos",
  "fieldsRosterListEmpty": "Su cuenta de granja no tiene campos",
  "fieldsRosterNewFieldButton": "Nuevo campo",
  "fieldsRosterSortKeys": {
    "alphabetical": "Nombre del campo",
    "fieldStatus": "Estado del campo"
  },
  "fieldsRosterTitle": "Campos",
  "fieldsRosterTitleWithItemCount": "Campos ({{itemCount}})",
  "setFieldBoundaryInstructions": [
    "Dibuja tu campo tocando el mapa. El campo debe tener al menos 3 puntos y estar completamente cerrado.\n\nSi quieres empezar de nuevo, haz clic/presiona Comenzar de nuevo.\n\nTambién podrás cambiar la forma del campo más adelante si es necesario."
  ],
  "setFieldBoundaryTitle": "Dibujar el límite del campo",
  "setFieldLabelRotationDragSliderHint": "Mueva el control deslizante para ajustar la dirección de la etiqueta",
  "setFieldLabelRotationInstructions": "Establezca la rotación de la etiqueta del campo según sea necesario",
  "setFieldLabelRotationLabel": "Rotación",
  "setFieldLabelRotationTitle": "Establecer la rotación de etiquetas",
  "setFieldNameInputLabel": "Nombre del campo",
  "setFieldNameInstructions": "Introduzca un nombre para el campo",
  "setFieldNameLinkTo": "Editar etiqueta",
  "setFieldNamePlaceholderText": "¿Cómo se llama el campo?",
  "setFieldNameTitle": "Introduzca el nombre del campo",
  "setFieldRowDirectionDragSliderHint": "Mueva el control deslizante para ajustar la dirección de la fila",
  "setFieldRowDirectionFlipButton": "Voltear",
  "setFieldRowDirectionInstructions": "Establecer la dirección de la fila del campo",
  "setFieldRowDirectionLinkTo": "Establecer la dirección de la fila",
  "setFieldRowDirectionTitle": "Establecer la dirección de la fila",
  "sortFields": "Ordenar campos",
  "updateFieldBoundaryInstructions": "Actualiza tu campo arrastrando puntos en el mapa. El campo debe tener al menos 3 puntos y estar completamente cerrado.",
  "updateFieldBoundaryTitle": "Dibujar el límite del campo"
}
